export default "__VITE_ASSET__dbc4bc70__"